import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Animated, Platform } from 'react-native';
import { AnimatedPressable, component, InputView, SmallView } from '@serviceos-rn/core';
import { TipConfig } from '../../../TipConfig';
import { TipConfiguration } from '../../../Domain/DTOs/TipConfigurationDTO';
export const OptionView = component({
    provider: TipConfig.provider,
    moduleName: TipConfig.moduleName,
    componentName: TipConfiguration.ComponentNames.option,
    style(theme, mediaQuery, window, props) {
        var _a, _b, _c, _d;
        return {
            container: Object.assign(Object.assign(Object.assign({ margin: 8, alignItems: 'center', paddingVertical: 15, paddingHorizontal: 16, borderRadius: 8 }, Platform.select({
                android: {
                    elevation: 4
                },
                default: {
                    shadowColor: 'rgb(189, 204, 224)',
                    shadowOffset: {
                        width: 0,
                        height: 2.0
                    },
                    shadowOpacity: 0.9,
                    shadowRadius: 5
                }
            })), { backgroundColor: theme.useSimpeAnimatedValue('backgroundColor', props.value.value ? 1 : 0, { duration: 200 }).interpolate({
                    inputRange: [0, 1],
                    outputRange: [
                        ((_a = theme.colors) === null || _a === void 0 ? void 0 : _a.link_color) || 'rgb(255, 255, 255)',
                        ((_b = theme.colors) === null || _b === void 0 ? void 0 : _b.secondary_color) || 'rgb(46, 103, 203)'
                    ]
                }) }), props.containerStyle),
            text: Object.assign({ fontSize: 18, color: theme.useSimpeAnimatedValue('backgroundColor', props.value.value ? 1 : 0, { duration: 200 }).interpolate({
                    inputRange: [0, 1],
                    outputRange: [
                        ((_c = theme.colors) === null || _c === void 0 ? void 0 : _c.text) || 'rgb(79, 101, 126)',
                        'rgb(255, 255, 255)'
                    ]
                }) }, props.textStyle),
            choiceItems: {
                marginTop: 30,
                flexDirection: 'row',
                flexWrap: 'wrap',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                overflow: 'hidden',
                maxHeight: theme.useSimpeAnimatedValue('choiceItems', props.value.value
                    ? 150
                    : 0),
                opacity: (_d = theme.getAnimation('choiceItems')) === null || _d === void 0 ? void 0 : _d.interpolate({
                    inputRange: [0, 150],
                    outputRange: [0, 1]
                })
            },
            input: {
                minWidth: 240,
                minHeight: 90,
            },
            inputText: {
                color: '#394E66',
                fontSize: 16,
                lineHeight: 18
            }
        };
    }
})(({ style, value, onChange, onSubmit }) => {
    var _a;
    const handleChange = useCallback(() => {
        const update = Object.assign(Object.assign({}, value), { value: 1 });
        onChange === null || onChange === void 0 ? void 0 : onChange(update);
    }, [value]);
    const handleItemChange = useCallback((item) => {
        var _a;
        const update = Object.assign(Object.assign({}, value), { value: 1, focused: true, choice_items: (_a = value.choice_items) === null || _a === void 0 ? void 0 : _a.map(choiceItem => {
                return choiceItem.id === item.id
                    ? item
                    : choiceItem;
            }) });
        onChange === null || onChange === void 0 ? void 0 : onChange(update);
    }, [value]);
    const handleItemBlur = useCallback(() => {
        const update = Object.assign(Object.assign({}, value), { value: 1, focused: false });
        onChange === null || onChange === void 0 ? void 0 : onChange(update);
    }, [value]);
    return (_jsxs(_Fragment, { children: [_jsx(AnimatedPressable, { testID: `button-${value.title}`, style: style === null || style === void 0 ? void 0 : style.container, onPress: handleChange, children: _jsx(Animated.Text, { style: style === null || style === void 0 ? void 0 : style.text, children: value.title }) }), (value.choice_items || []).length > 0 && (_jsx(Animated.View, { style: style === null || style === void 0 ? void 0 : style.choiceItems, children: (_a = value.choice_items) === null || _a === void 0 ? void 0 : _a.map(item => {
                    var _a, _b, _c;
                    return (_jsx(InputView, { onBlur: handleItemBlur, testID: value.title, underline: false, containerStyle: style === null || style === void 0 ? void 0 : style.input, extError: item.error, before: ((_a = item.customize) === null || _a === void 0 ? void 0 : _a.prefix)
                            ? () => {
                                var _a;
                                return (_jsx(SmallView, { textStyle: style === null || style === void 0 ? void 0 : style.inputText, children: (_a = item.customize) === null || _a === void 0 ? void 0 : _a.prefix }));
                            }
                            : undefined, after: ((_b = item.customize) === null || _b === void 0 ? void 0 : _b.suffix)
                            ? () => {
                                var _a;
                                return (_jsx(SmallView, { textStyle: style === null || style === void 0 ? void 0 : style.inputText, children: (_a = item.customize) === null || _a === void 0 ? void 0 : _a.suffix }));
                            }
                            : undefined, placeholder: (_c = item.customize) === null || _c === void 0 ? void 0 : _c.placeholder, value: item.value, returnKeyType: 'done', onSubmitEditing: onSubmit, onChangeText: (text) => {
                            if (isNaN(Number(text))) {
                                return;
                            }
                            const update = Object.assign(Object.assign({}, item), { value: Number(text) });
                            handleItemChange(update);
                        }, keyboardType: "numeric" }, item.id));
                }) }))] }));
});
